import {
	connect
} from 'react-redux'
import DataTable from '../components/common/DataTable.jsx';

const mapStateToProps = (state) => ({
	data: state.getIn(['maintenanceSearchReducer', 'search_details']),
	activePage: 1,
	itemPerPage: 100,
	totalPage: 1,
	pagingMaxButtons: 1,
	fields: {
		set_description: '類別',
		item_description: '維修項目',
		note: '附註',
		status_desc: '狀態',
		refine_status_desc: ''
	},
	keys: ['id'],
	disableAdd: true,
	disableEdit: true,
	hidePaging: true
})

const mapDispatchToProps = (dispatch) => ({
	refresh: (payload) => {
	},
	changeActivepage: (pagingData) => {
		//不分頁，不處理
	}
})

const SearchMRecordDetailListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DataTable)

export default SearchMRecordDetailListContainer;


// WEBPACK FOOTER //
// ./src/containers/SearchMRecordDetailListContainer.jsx